module.exports = __webpack_public_path__ + "static/logo_do_paty-c42ebe05990599cf161912be43101119.svg";